<svg
  id="Layer_2"
  data-name="Layer 2"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 861.1 348.42"
  fill="currentColor"
  height="36"
  style="clear: right"
>
  <path
    d="M861.1,90.42v17.42l-1.37,10.04c-4.17,21.43-15.41,41.39-31.83,55.75-.14.67,6.62,6.87,7.67,8.04,12.21,13.62,20.73,30.43,24.15,48.46l1.38,10.03v17.01l-1.38,10.03c-7.79,42.31-43.31,75.28-86.07,80.34-2.73.32-5.82.15-8.46.88h-181.02V49.36h-110.02v299.07h-49.41V49.36h-137.22L259.08,0h511.3c47.12,4.02,86.52,42.09,90.29,89.42l.43,1ZM633.99,149.32l128.1.02c64.47-3.22,66.2-92.88,3.74-100l-131.84.02v99.97ZM633.99,298.65l130.59.02c62.8-5.63,62.39-94.91-.42-100l-130.18.02v99.97Z"
  />
  <polygon
    points="402.32 348.42 114.18 348.42 142.41 298.65 316.79 298.65 201.16 98.72 57.3 348.42 0 348.42 201.16 0 402.32 348.42"
  />
</svg>
<Text display="block" style="font-size: 10px; line-height: 12px"
  >Assurant Trade Bridge</Text
>
